"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgTriangle = function SvgTriangle(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M21.432 16.346l.003-.005a3 3 0 015.133.005L35.046 30.5A3 3 0 0132.47 35H15.519a3 3 0 01-2.557-4.514l8.47-14.14zM14.686 31.5a1 1 0 00.844 1.5h16.929a1 1 0 00.863-1.486l-8.467-14.135a1 1 0 00-1.709-.002L14.686 31.5z",
    id: "triangle_svg__a"
  }));
};

var _default = SvgTriangle;
exports["default"] = _default;